import { all, call, put, takeLatest } from 'redux-saga/effects'
import agent from 'agent'
import appMode from 'helpers/getAppMode'
import { exportSaga } from './export.sagas'

import * as actions from 'redux/actions/notification.actions'

function* getNotificationSaga(params) {
  try {
    const { domainId, filters } = params.payload
    const request = appMode.share ? agent.Share.notifications : agent.Keywords.notifications
    const body = yield call(request, domainId, filters)
    const notification = body.data
    yield put(actions.getNotificationOverviewSuccess(notification, domainId))
  } catch (error) {
    yield put(actions.getNotificationOverviewFailure(error))
  }
}

function* exportKeywordNotificationsExcelSaga(params) {
  yield call(exportSaga, {
    params: params.payload,
    type: 'xls',
    request: agent.Keywords.exportNotificationsExcel,
    requestShared: agent.Share.exportShareNotificationsExcel
  })
}

function* exportKeywordNotificationsCSVSaga(params) {
  yield call(exportSaga, {
    params: params.payload,
    type: 'csv',
    request: agent.Keywords.exportNotificationsCSV,
    requestShared: agent.Share.exportShareNotificationsCSV
  })
}

export default function* notificationSagas() {
  yield all([
    takeLatest(actions.getNotificationOverview.type, getNotificationSaga),
    takeLatest(
      actions.exportDomainKeywordNotificationsExcel.type,
      exportKeywordNotificationsExcelSaga
    ),
    takeLatest(actions.exportDomainKeywordNotificationsCSV.type, exportKeywordNotificationsCSVSaga)
  ])
}
